import { render, staticRenderFns } from "./Dia.vue?vue&type=template&id=666b5d98&"
import script from "./Dia.vue?vue&type=script&lang=js&"
export * from "./Dia.vue?vue&type=script&lang=js&"
import style0 from "./Dia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
